import { UseFormReturnType } from "@mantine/form";
import { Editor } from "@tiptap/react";
import { RequestBaseFields } from "../types/request.types";
import { humanize } from "inflection";
import { useEffect } from "react";
import useCurrentUser from "./use-current-user";

export function convertRequest<T>(request: RequestBaseFields) {
  const currentUser = useCurrentUser();
  const displayName = currentUser.name ?
    currentUser.name : currentUser.email ?
      currentUser.email : currentUser.username;
  const fields: any = {};
  const genericFields = [
    'id',
    'name',
    'status',
    'created_at',
    'status',
    'request_type',
    'user',
    'contacts',
    'user_contacts',
    'combined_contacts',
    'assigned_users',
    'requested_completion_date',
  ];

  let desc = `<p>Converted from <strong>${humanize(request.request_type)}: ${request.name}</strong>`;
  desc += ` by ${displayName}</p>`;

  if (request.request_type !== 'business_card_request') {
    fields.requested_completion_date = (request as any).requested_completion_date;
  }

  Object.entries(request).forEach(([key, value]) => {
    if (genericFields.includes(key)) return;
    if (!value) return;
    desc += `<dt><strong>${humanize(key)}</strong></dt><dd>${value}</dd>`;
  });

  fields.name = request.name;
  desc = `<dl>${desc.trim()}</dl>`;
  fields.description = desc;

  return fields;
}

export function useConvertFrom<T>(
  form: UseFormReturnType<T>,
  editor: Editor | null,
  request: RequestBaseFields | null | undefined,
) {
  let fromFields: any = {};
  if (request) fromFields = convertRequest(request);

  useEffect(() => {
    if (fromFields.description && editor)
      editor.commands.setContent(fromFields.description);

    if (fromFields.name) form.setFieldValue('name', fromFields.name);

    if (fromFields.requested_completion_date)
      form.setFieldValue('requested_completion_date', fromFields.requested_completion_date);
  }, [fromFields, form, editor]);
}
